/*
  Plain asset file, loaded from sections/header.liquid with a deferred
  script tag. Not a Liquid "javascript" block and no longer inline: the
  Shopify CLI dev bundler truncates the compiled scripts.js wrapper
  (unclosed catch, whole-bundle SyntaxError), which silently killed all
  section JS in dev. Serving this as its own asset avoids that bundler bug
  AND the ~22KB of per-page inline HTML weight the previous inline script
  added. `defer` executes after parsing but before DOMContentLoaded, so the
  DOMContentLoaded wrapper below still fires and preserves the
  deferred-bundle timing this code was written for.

  NB: never write the literal javascript Liquid tag in this file (even in a
  comment) — the asset compiler scans raw source for it.
*/
  document.addEventListener('DOMContentLoaded', function () {
  function sanitizeFloatingPos(storageKey) {
    if (!storageKey) return;
    try {
      var raw = localStorage.getItem(storageKey);
      if (!raw) return;
      var pos = JSON.parse(raw);
      if (typeof pos.left !== 'number' || typeof pos.top !== 'number') {
        localStorage.removeItem(storageKey);
        return;
      }
      if (pos.left < 8 && pos.top < 8) {
        localStorage.removeItem(storageKey);
        return;
      }
      if (pos.left > window.innerWidth - 48 || pos.top > window.innerHeight - 48) {
        localStorage.removeItem(storageKey);
      }
    } catch (e) {
      try { localStorage.removeItem(storageKey); } catch (err) { /* ignore */ }
    }
  }

  function hasValidStoredPos(el, storageKey) {
    if (!storageKey || !el) return false;
    try {
      var raw = localStorage.getItem(storageKey);
      if (!raw) return false;
      var pos = JSON.parse(raw);
      if (typeof pos.left !== 'number' || typeof pos.top !== 'number') return false;
      if (pos.left < 8 && pos.top < 8) return false;
      var rect = el.getBoundingClientRect();
      var w = rect.width || el.offsetWidth || 320;
      var h = rect.height || el.offsetHeight || 180;
      if (pos.left + w > window.innerWidth + 8) return false;
      if (pos.top + h > window.innerHeight + 8) return false;
      return true;
    } catch (e) {
      return false;
    }
  }

  function clearFloatingInlinePos(el) {
    if (!el) return;
    ['left', 'top', 'right', 'bottom', 'inset', 'z-index'].forEach(function (prop) {
      el.style.removeProperty(prop);
    });
  }

  function placeFloatingUi(el, storageKey) {
    if (!el) return;
    var query = el.dataset.bwwMinWidthQuery || '(min-width: 769px)';
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        var desktop = window.matchMedia(query).matches;
        if (!desktop) {
          if (el.bwwResetToDefaultCorner) el.bwwResetToDefaultCorner();
          return;
        }
        if (storageKey && hasValidStoredPos(el, storageKey) && el.bwwRestorePos) {
          el.bwwRestorePos();
        } else if (el.bwwResetToDefaultCorner) {
          el.bwwResetToDefaultCorner();
        }
      });
    });
  }

  function mountFestivalWidgetAndDrag() {
    var widgets = Array.prototype.slice.call(document.querySelectorAll('.festival-widget'));
    if (!widgets.length) return;
    var widget = widgets.find(function (el) { return el.dataset.bwwMount !== '1'; }) || widgets[0];
    widgets.forEach(function (el) {
      if (el !== widget) el.remove();
    });
    widget.style.position = 'fixed';
    clearFloatingInlinePos(widget);
    sanitizeFloatingPos('bww:festival-widget-pos');

    if (widget.dataset.bwwMount === '1') {
      placeFloatingUi(widget, 'bww:festival-widget-pos');
      return;
    }
    widget.dataset.bwwMount = '1';
    document.body.appendChild(widget);

    if (window.bwwMakeDraggable) {
      window.bwwMakeDraggable(widget, {
        storageKey: 'bww:festival-widget-pos',
        minWidthQuery: '(min-width: 769px)',
        defaultCorner: 'bottom-left',
        deferInitialPosition: true
      });
    }
    placeFloatingUi(widget, 'bww:festival-widget-pos');
  }

  // Shared draggable helper: drag a fixed-position element on desktop only.
  // Persists position to localStorage by `storageKey` (optional). Skip drag when target is inside [data-no-drag].
  window.bwwMakeDraggable = window.bwwMakeDraggable || function bwwMakeDraggable(el, options) {
    if (!el) return;
    if (el.dataset.bwwDraggable === '1') {
      if (options && options.minWidthQuery) el.dataset.bwwMinWidthQuery = options.minWidthQuery;
      if (options && options.defaultCorner) el.dataset.bwwDefaultCorner = options.defaultCorner;
      if (options && options.dragHandleOnly) el.dataset.bwwDragHandleOnly = '1';
      if (typeof el.bwwResetToDefaultCorner === 'function' && options && options.storageKey) {
        sanitizeFloatingPos(options.storageKey);
      }
      return;
    }
    el.dataset.bwwDraggable = '1';
    var opts = options || {};
    var storageKey = opts.storageKey;
    var minWidthQuery = opts.minWidthQuery || '(min-width: 769px)';
    el.dataset.bwwMinWidthQuery = minWidthQuery;
    if (opts.defaultCorner) el.dataset.bwwDefaultCorner = opts.defaultCorner;
    if (opts.dragHandleOnly) el.dataset.bwwDragHandleOnly = '1';

    function isDraggableLayout() {
      var query = el.dataset.bwwMinWidthQuery || minWidthQuery;
      return window.matchMedia(query).matches;
    }

    // Write position with `important` priority so it overrides anchored
    // `!important` rules (e.g. the mini player's bottom/right defaults).
    function setPos(nx, ny, isDrag) {
      el.style.setProperty('left', nx + 'px', 'important');
      el.style.setProperty('top', ny + 'px', 'important');
      el.style.setProperty('bottom', 'auto', 'important');
      el.style.setProperty('right', 'auto', 'important');
      // Do not set `inset` here — it is a shorthand and would reset left/top to auto.
      // Only flag a *real* user drag (or a restored drag). Default-corner placement
      // must NOT set this, so the CSS `:not([data-bww-dragged])` anchor stays authoritative.
      if (isDrag) el.dataset.bwwDragged = '1';
    }

    function readSize() {
      var rect = el.getBoundingClientRect();
      return {
        width: rect.width || el.offsetWidth || 320,
        height: rect.height || el.offsetHeight || 180
      };
    }

    function getDefaultCorner() {
      return el.dataset.bwwDefaultCorner || 'bottom-right';
    }

    function defaultCornerPosition() {
      var size = readSize();
      var margin = 16;
      var corner = getDefaultCorner();
      var top = Math.max(12, window.innerHeight - size.height - margin);
      var left;
      if (corner === 'bottom-left') {
        left = margin;
      } else {
        left = Math.max(12, window.innerWidth - size.width - margin);
      }
      return { left: left, top: top };
    }

    function anchorFromVisualPosition() {
      var rect = el.getBoundingClientRect();
      var size = readSize();
      if (!rect.width && !rect.height) {
        var corner = defaultCornerPosition();
        setPos(corner.left, corner.top, true);
        return corner;
      }
      var nx = Math.max(0, Math.min(window.innerWidth - size.width, Math.round(rect.left)));
      var ny = Math.max(0, Math.min(window.innerHeight - size.height, Math.round(rect.top)));
      setPos(nx, ny, true);
      return { left: nx, top: ny };
    }

    function isValidStoredPos(pos) {
      if (typeof pos.left !== 'number' || typeof pos.top !== 'number') return false;
      if (pos.left < 8 && pos.top < 8) return false;
      var size = readSize();
      if (pos.left + size.width > window.innerWidth + 8) return false;
      if (pos.top + size.height > window.innerHeight + 8) return false;
      return true;
    }

    function resetToDefaultCorner() {
      try { if (storageKey) localStorage.removeItem(storageKey); } catch (e) { /* ignore */ }
      delete el.dataset.bwwDragged;
      ['left', 'top', 'right', 'bottom', 'inset'].forEach(function (prop) {
        el.style.removeProperty(prop);
      });
      // Default resting position is owned by CSS (.X:not([data-bww-dragged="1"])):
      //   festival-widget -> bottom-left, switcher -> bottom-right, mini player -> bottom-right.
      // No JS px placement here -> no first-paint size race, and naturally responsive.
    }

    function restore() {
      if (!isDraggableLayout()) return;
      if (!storageKey) {
        resetToDefaultCorner();
        return;
      }
      try {
        var raw = localStorage.getItem(storageKey);
        if (!raw || !isValidStoredPos(JSON.parse(raw))) {
          resetToDefaultCorner();
          return;
        }
        var pos = JSON.parse(raw);
        var size = readSize();
        var nx = Math.max(0, Math.min(window.innerWidth - size.width, pos.left));
        var ny = Math.max(0, Math.min(window.innerHeight - size.height, pos.top));
        setPos(nx, ny, true);
      } catch (e) {
        resetToDefaultCorner();
      }
    }

    function persist() {
      if (!storageKey) return;
      try {
        var rect = el.getBoundingClientRect();
        localStorage.setItem(storageKey, JSON.stringify({ left: rect.left, top: rect.top }));
      } catch (e) { /* ignore */ }
    }

    el.style.touchAction = 'none';
    el.bwwRestorePos = restore;
    el.bwwResetToDefaultCorner = resetToDefaultCorner;
    el.bwwAnchorFromLayout = anchorFromVisualPosition;
    if (!opts.deferInitialPosition) {
      restore();
    }

    var startX, startY, origLeft, origTop, hasMoved;

    function applyMove(clientX, clientY, ev) {
      if (!isDraggableLayout()) return;
      var dx = clientX - startX;
      var dy = clientY - startY;
      if (!hasMoved && Math.abs(dx) < 5 && Math.abs(dy) < 5) return;
      if (ev && ev.cancelable) ev.preventDefault();
      if (!hasMoved) {
        hasMoved = true;
        // First real movement: convert CSS corner position to top/left without jumping.
        setPos(origLeft, origTop, true);
      }
      var nx = Math.max(0, Math.min(window.innerWidth - el.offsetWidth, origLeft + dx));
      var ny = Math.max(0, Math.min(window.innerHeight - el.offsetHeight, origTop + dy));
      setPos(nx, ny, true);
    }

    function onMouseMove(e) { applyMove(e.clientX, e.clientY, e); }
    function onTouchMove(e) {
      if (!e.touches || !e.touches[0]) return;
      applyMove(e.touches[0].clientX, e.touches[0].clientY, e);
    }
    function endDrag() {
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', endDrag);
      document.removeEventListener('touchmove', onTouchMove, true);
      document.removeEventListener('touchend', endDrag);
      document.removeEventListener('touchcancel', endDrag);
      el.classList.remove('is-dragging');
      el.style.transition = '';
      if (hasMoved) {
        persist();
        // Flag so the click that follows a drag doesn't trigger click-to-expand.
        el.dataset.bwwJustDragged = '1';
        window.setTimeout(function () { delete el.dataset.bwwJustDragged; }, 220);
      }
      hasMoved = false;
    }

    function shouldIgnore(target) {
      if (!target || !target.closest) return false;
      if (target.closest('[data-bww-mini-drag], [data-bww-drag-handle]')) return false;
      if (el.dataset.bwwDragHandleOnly === '1') {
        return !target.closest('[data-bww-drag-handle]');
      }
      return !!target.closest('[data-no-drag], a, button, input, select, textarea, label');
    }

    function onMouseDown(e) {
      if (!isDraggableLayout()) return;
      if (e.button !== 0) return;
      if (shouldIgnore(e.target)) return;
      var rect = el.getBoundingClientRect();
      startX = e.clientX;
      startY = e.clientY;
      origLeft = Math.round(rect.left);
      origTop = Math.round(rect.top);
      hasMoved = false;
      el.classList.add('is-dragging');
      el.style.transition = 'none';
      e.preventDefault();
      e.stopPropagation();
      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', endDrag);
    }

    function onTouchStart(e) {
      if (!isDraggableLayout()) return;
      if (!e.touches || !e.touches[0]) return;
      if (shouldIgnore(e.target)) return;
      var rect = el.getBoundingClientRect();
      var t = e.touches[0];
      startX = t.clientX;
      startY = t.clientY;
      origLeft = Math.round(rect.left);
      origTop = Math.round(rect.top);
      hasMoved = false;
      el.classList.add('is-dragging');
      el.style.transition = 'none';
      document.addEventListener('touchmove', onTouchMove, { passive: false, capture: true });
      document.addEventListener('touchend', endDrag, { passive: false });
      document.addEventListener('touchcancel', endDrag, { passive: false });
    }

    el.addEventListener('mousedown', onMouseDown, true);
    el.addEventListener('touchstart', onTouchStart, { passive: false, capture: true });

    // Re-anchor on viewport changes so positions never go stale until reload.
    // Not-dragged elements are left to their responsive CSS corner; only a
    // currently-dragged element is re-clamped back into the viewport. We deliberately
    // do NOT call restore() here: this same helper drives the video <dialog>, which
    // toggles between a full-screen modal and the floating mini player, and restore()
    // would otherwise re-apply the saved mini position onto the full-screen modal.
    var viewportRaf = null;
    function onViewportChange() {
      if (viewportRaf) return;
      viewportRaf = window.requestAnimationFrame(function () {
        viewportRaf = null;
        if (!isDraggableLayout()) {
          // Entering the mobile/non-draggable layout: drop desktop inline px so the
          // responsive CSS (e.g. the full-width bottom bar) governs.
          delete el.dataset.bwwDragged;
          ['left', 'top', 'right', 'bottom', 'inset'].forEach(function (p) { el.style.removeProperty(p); });
          return;
        }
        if (el.dataset.bwwDragged === '1') anchorFromVisualPosition();
      });
    }
    window.addEventListener('resize', onViewportChange, { passive: true });
    window.addEventListener('orientationchange', onViewportChange, { passive: true });
    try {
      window.matchMedia(el.dataset.bwwMinWidthQuery || minWidthQuery)
        .addEventListener('change', onViewportChange);
    } catch (e) { /* older Safari: no MediaQueryList.addEventListener */ }
  };

  function resetSwitcherToCorner() {
    var bar = document.querySelector('.bww-switcher-bar');
    if (!bar) return;
    if (typeof bar.bwwResetToDefaultCorner === 'function') bar.bwwResetToDefaultCorner();
    else {
      delete bar.dataset.bwwDragged;
      ['left', 'top', 'right', 'bottom', 'inset'].forEach(function (prop) {
        bar.style.removeProperty(prop);
      });
    }
  }

  function mountSwitcherDrag() {
    var bar = document.querySelector('.bww-switcher-bar');
    if (!bar) return;
    bar.style.position = 'fixed';
    clearFloatingInlinePos(bar);
    // Drop legacy persisted switcher position (was site-wide across pages + refresh).
    try { localStorage.removeItem('bww:switcher-pos'); } catch (e) { /* ignore */ }

    if (bar.dataset.bwwMount === '1') {
      resetSwitcherToCorner();
      return;
    }
    bar.dataset.bwwMount = '1';
    document.body.appendChild(bar);

    if (window.bwwMakeDraggable) {
      window.bwwMakeDraggable(bar, {
        minWidthQuery: '(min-width: 769px)',
        defaultCorner: 'bottom-right',
        dragHandleOnly: true,
        deferInitialPosition: true
      });
    }
    resetSwitcherToCorner();

    if (!window.__bwwSwitcherPageshowBound) {
      window.__bwwSwitcherPageshowBound = true;
      window.addEventListener('pageshow', function (e) {
        if (!e.persisted) return;
        resetSwitcherToCorner();
      });
    }
  }

  function mountDraggables() {
    mountFestivalWidgetAndDrag();
    mountSwitcherDrag();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountDraggables);
  } else {
    mountDraggables();
  }

  const header = document.querySelector('[data-header]');
  const menuToggle = header && header.querySelector('[data-menu-toggle]');
  const menuClose = header && header.querySelector('[data-menu-close]');
  const mobileNav = header && header.querySelector('[data-mobile-nav]');

  if (menuToggle && mobileNav) {
    const openMenu = () => {
      if (mobileNav.open) return;
      mobileNav.showModal();
      menuToggle.setAttribute('aria-expanded', 'true');
      // Land focus on the close button instead of the first link.
      if (menuClose) requestAnimationFrame(() => menuClose.focus());
    };
    const closeMenu = () => {
      if (mobileNav.open) mobileNav.close();
    };

    menuToggle.addEventListener('click', openMenu);
    if (menuClose) menuClose.addEventListener('click', closeMenu);

    // Backdrop click closes (native dialog reports itself as the target).
    mobileNav.addEventListener('click', (e) => {
      if (e.target === mobileNav) closeMenu();
    });

    // Close after following any in-menu link. Delegated (not per-link):
    // most drawer links are stamped in lazily after this init runs.
    mobileNav.addEventListener('click', (e) => {
      if (e.target.closest('a')) closeMenu();
    });

    // Keep the toggle in sync however the dialog closes (Esc, backdrop,
    // link, programmatic) and return focus to the trigger.
    mobileNav.addEventListener('close', () => {
      menuToggle.setAttribute('aria-expanded', 'false');
      menuToggle.focus();
    });
  }

  (function () {
    var menus = Array.prototype.slice.call(
      document.querySelectorAll('.header__expo-dropdown[data-header-expo-menu]')
    ).filter(function (el) { return el.tagName === 'DETAILS'; });
    if (!menus.length) return;

    menus.forEach(function (details) {
      // A link click navigates away — collapse the panel behind it.
      // Delegated because panel bodies are stamped in lazily after init;
      // plan-week's grid/preview stopPropagation() keeps its in-panel
      // day-picker clicks from closing the menu, same as before.
      details.addEventListener('click', function (e) {
        if (e.target.closest('a')) details.open = false;
      });
      // Opening one menu closes any sibling that's still open (single-open nav).
      details.addEventListener('toggle', function () {
        if (!details.open) return;
        menus.forEach(function (other) {
          if (other !== details && other.open) other.open = false;
        });
      });
    });

    // One document-level listener for the whole set, not one per menu.
    document.addEventListener('click', function (e) {
      menus.forEach(function (details) {
        if (details.open && !details.contains(e.target)) details.open = false;
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      menus.forEach(function (details) {
        if (details.open) details.open = false;
      });
    });
  })();

  // What's Selling Fast — leaderboard behaviour. The Liquid render is
  // cached by Shopify, so the per-visit variety lives here: shuffle the
  // rows once per page load, then, while the menu is open, periodically
  // let a row from the lower half climb two or three places with a
  // highlight — like a chart position changing, not a feed jumping to #1.
  (function () {
    var lists = document.querySelectorAll('[data-selling-fast-feed]');
    if (!lists.length) return;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    Array.prototype.forEach.call(lists, function (list) {
      var rows = Array.prototype.slice.call(list.children);
      if (rows.length < 2) return;

      for (var i = rows.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = rows[i];
        rows[i] = rows[j];
        rows[j] = tmp;
      }
      rows.forEach(function (row) { list.appendChild(row); });

      // Row indices drive the CSS entrance stagger. Stamped at init and on
      // each open only — re-stamping mid-rotation changes animation-delay
      // on settled rows, which some browsers treat as a restart (rows blink
      // out through the backwards-fill delay).
      var stamp = function () {
        Array.prototype.forEach.call(list.children, function (row, idx) {
          row.style.setProperty('--sf-i', idx);
        });
      };
      stamp();

      var timer = null;

      var rotate = function () {
        var kids = list.children;
        if (kids.length < 4) return;
        // Leave the reader alone: no jumps while they're scrolled into the
        // list, hovering a row, or in another tab.
        if (document.hidden || list.scrollTop > 4 || list.matches(':hover')) return;
        // Leaderboard climb: pick a row from the lower half and move it up
        // two or three places (never straight to the top).
        var half = Math.floor(kids.length / 2);
        var idx = half + Math.floor(Math.random() * (kids.length - half));
        var climb = 2 + Math.floor(Math.random() * 2);
        var row = kids[idx];
        var target = kids[Math.max(1, idx - climb)];
        row.classList.remove('is-fresh');
        list.insertBefore(row, target);
        void row.offsetWidth; // restart the highlight animation
        row.classList.add('is-fresh');
      };

      var start = function () {
        stamp();
        list.classList.add('is-live');
        if (timer || reduceMotion.matches) return;
        timer = window.setInterval(rotate, 5000);
      };
      var stop = function () {
        list.classList.remove('is-live');
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      };

      var details = list.closest('details');
      if (details) {
        details.addEventListener('toggle', function () {
          if (details.open) start();
          else stop();
        });
        if (details.open) start();
      } else {
        start();
      }
    });
  })();

  if (header) {
    // --header-height sync lives inline next to the <header> markup —
    // layout-critical, must not depend on this bundle loading/parsing.
    let ticking = false;
    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          header.classList.toggle('header--scrolled', window.scrollY > 10);
          ticking = false;
        });
        ticking = true;
      }
    });
  }

  // Countdown timer
  document.querySelectorAll('[data-countdown]').forEach((countdownEl) => {
    if (countdownEl.dataset.countdownInit === '1') return;
    countdownEl.dataset.countdownInit = '1';
    const target = new Date(countdownEl.dataset.countdown).getTime();
    const days = countdownEl.querySelector('[data-days]');
    const hours = countdownEl.querySelector('[data-hours]');
    const mins = countdownEl.querySelector('[data-mins]');
    const secs = countdownEl.querySelector('[data-secs]');

    if (days && hours && mins && secs) {
      let countdownTimer = null;
      function tick() {
        const diff = target - Date.now();
        if (diff <= 0) {
          days.textContent = '00';
          hours.textContent = '00';
          mins.textContent = '00';
          secs.textContent = '00';
          if (countdownTimer) { clearInterval(countdownTimer); countdownTimer = null; }
          return;
        }
        const d = Math.floor(diff / 86400000);
        const h = Math.floor((diff % 86400000) / 3600000);
        const m = Math.floor((diff % 3600000) / 60000);
        const s = Math.floor((diff % 60000) / 1000);
        days.textContent = String(d).padStart(2, '0');
        hours.textContent = String(h).padStart(2, '0');
        mins.textContent = String(m).padStart(2, '0');
        secs.textContent = String(s).padStart(2, '0');
      }

      tick();
      if (target - Date.now() > 0) {
        countdownTimer = setInterval(tick, 1000);
        document.addEventListener('shopify:section:unload', function () {
          if (countdownTimer) { clearInterval(countdownTimer); countdownTimer = null; }
        });
      }
    }
  });

  // Logo rotator (desktop + mobile)
  const prefersReducedMotion = window.matchMedia
    && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('[data-logo-rotator], [data-mobile-logo-rotator]').forEach(function(rotator) {
    const logos = rotator.querySelectorAll('.header__brand-logo--rotate, .header__mobile-brand-logo--rotate');
    if (logos.length > 0) {
      let current = 0;
      logos[0].classList.add('is-active');
      // Hold a single static mark when the user prefers reduced motion.
      if (logos.length > 1 && !prefersReducedMotion) {
        const rotatorTimer = setInterval(function() {
          logos[current].classList.remove('is-active');
          current = (current + 1) % logos.length;
          logos[current].classList.add('is-active');
        }, 3000);
        document.addEventListener('shopify:section:unload', function () {
          clearInterval(rotatorTimer);
        });
      }
    }
  });

  // Sister-festival switcher pill — pop in, shrink on scroll down / grow on scroll up,
  // and float just above the countdown bar (mobile).
  (function () {
    const pill = document.querySelector('[data-festival-pill]');
    if (!pill || pill.dataset.pillInit === '1') return;
    pill.dataset.pillInit = '1';

    const widget = document.querySelector('.festival-widget');

    function positionPill() {
      if (!widget) return;
      const h = widget.getBoundingClientRect().height;
      if (h > 0) pill.style.setProperty('--festival-pill-bottom', h + 'px');
    }

    const NARROW_AT = 100; // px scrolled before the bar may shrink
    const DELTA = 6;       // ignore sub-pixel scroll jitter
    let lastY = window.scrollY || window.pageYOffset || 0;
    let ticking = false;

    function update() {
      ticking = false;
      const y = window.scrollY || window.pageYOffset || 0;
      if (y < NARROW_AT) {
        pill.classList.remove('is-narrow');   // near the top → wide
      } else if (y > lastY + DELTA) {
        pill.classList.add('is-narrow');        // scrolling down → shrink
      } else if (y < lastY - DELTA) {
        pill.classList.remove('is-narrow');     // scrolling up → grow
      }
      lastY = y;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    window.addEventListener('resize', positionPill, { passive: true });

    positionPill();
    setTimeout(positionPill, 400); // re-measure once fonts/layout settle

    // Pop / load in on the next frame so the entrance transition plays.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        positionPill();
        pill.classList.add('is-visible');
      });
    });
  })();

  // Search overlay — command-palette style predictive search. Markup in
  // snippets/header-search.liquid; results from Shopify's predictive
  // search API (/search/suggest.json). Keyboard: Cmd/Ctrl+K or `/` opens,
  // arrows walk the results, Enter follows, Esc closes (native dialog).
  (function () {
    var modal = document.querySelector('[data-search-modal]');
    if (!modal || modal.dataset.searchInit === '1') return;
    modal.dataset.searchInit = '1';

    var form = modal.querySelector('[data-search-form]');
    var input = modal.querySelector('[data-search-input]');
    var clearBtn = modal.querySelector('[data-search-clear]');
    var spinner = modal.querySelector('[data-search-spinner]');
    var resultsEl = modal.querySelector('[data-search-results]');
    var defaultEl = modal.querySelector('[data-search-default]');
    var recentWrap = modal.querySelector('[data-search-recent]');
    var recentList = modal.querySelector('[data-search-recent-list]');
    if (!form || !input || !resultsEl) return;

    var searchUrl = modal.dataset.searchUrl || '/search';
    var predictiveUrl = modal.dataset.predictiveUrl || '/search/suggest';
    var moneyFormat = modal.dataset.moneyFormat || '£{{ amount }}';
    var RECENT_KEY = 'bww:recent-searches';
    var MAX_RESULTS = 8;
    var debounceTimer = null;
    var controller = null;
    var cache = {};
    var cacheKeys = [];
    var options = [];
    var activeIndex = -1;
    var lastQuery = '';

    function formatMoney(value) {
      var n = parseFloat(value);
      if (isNaN(n)) return '';
      if (n === 0) return 'Free';
      // £35 reads cleaner than £35.00 in a compact row.
      var amount = n.toFixed(2).replace(/\.00$/, '');
      return moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/g, amount);
    }

    function priceLabel(p) {
      var min = p.price_min != null ? p.price_min : p.price;
      var max = p.price_max != null ? p.price_max : p.price;
      var label = formatMoney(min);
      if (!label) return '';
      if (parseFloat(max) > parseFloat(min)) return 'From ' + label;
      return label;
    }

    function readRecent() {
      try {
        var arr = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]');
        return Array.isArray(arr)
          ? arr.filter(function (t) { return typeof t === 'string' && t.trim(); })
          : [];
      } catch (e) {
        return [];
      }
    }

    function saveRecent(term) {
      term = (term || '').trim();
      if (!term) return;
      var arr = readRecent().filter(function (t) {
        return t.toLowerCase() !== term.toLowerCase();
      });
      arr.unshift(term);
      try { localStorage.setItem(RECENT_KEY, JSON.stringify(arr.slice(0, 5))); } catch (e) { /* ignore */ }
    }

    function renderRecent() {
      if (!recentWrap || !recentList) return;
      var arr = readRecent();
      recentList.textContent = '';
      if (!arr.length) {
        recentWrap.hidden = true;
        return;
      }
      arr.forEach(function (term) {
        var chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'header__search-chip';
        chip.dataset.searchTerm = term;
        chip.textContent = term;
        recentList.appendChild(chip);
      });
      recentWrap.hidden = false;
    }

    function setActive(idx, scroll) {
      if (activeIndex > -1 && options[activeIndex]) {
        options[activeIndex].classList.remove('is-active');
      }
      activeIndex = idx;
      if (idx > -1 && options[idx]) {
        options[idx].classList.add('is-active');
        input.setAttribute('aria-activedescendant', options[idx].id);
        if (scroll) options[idx].scrollIntoView({ block: 'nearest' });
      } else {
        input.removeAttribute('aria-activedescendant');
      }
    }

    function showDefault() {
      lastQuery = '';
      if (controller) { controller.abort(); controller = null; }
      if (spinner) spinner.hidden = true;
      resultsEl.hidden = true;
      resultsEl.textContent = '';
      if (defaultEl) defaultEl.hidden = false;
      input.setAttribute('aria-expanded', 'false');
      options = [];
      setActive(-1);
    }

    // Wrap query matches in <mark>, building text nodes only (API titles
    // and the visitor's query never touch innerHTML).
    function appendHighlighted(el, text, query) {
      var lower = text.toLowerCase();
      var q = query.toLowerCase();
      var from = 0;
      if (q) {
        var idx = lower.indexOf(q);
        while (idx !== -1) {
          if (idx > from) el.appendChild(document.createTextNode(text.slice(from, idx)));
          var mark = document.createElement('mark');
          mark.textContent = text.slice(idx, idx + q.length);
          el.appendChild(mark);
          from = idx + q.length;
          idx = lower.indexOf(q, from);
        }
      }
      if (from < text.length) el.appendChild(document.createTextNode(text.slice(from)));
    }

    function thumbUrl(p) {
      var url = (p.featured_image && p.featured_image.url) || p.image || '';
      if (!url) return '';
      // 2x for retina at the 3rem (48px) thumb size.
      return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=96';
    }

    function renderResults(query, products) {
      resultsEl.textContent = '';

      if (!products.length) {
        var empty = document.createElement('div');
        empty.className = 'header__search-empty';
        empty.appendChild(document.createTextNode('No matches for '));
        var strong = document.createElement('strong');
        strong.textContent = '“' + query + '”';
        empty.appendChild(strong);
        empty.appendChild(document.createTextNode(' — try a whiskey, venue or event name.'));
        resultsEl.appendChild(empty);
      }

      products.forEach(function (p, i) {
        var soldOut = p.available === false;
        var row = document.createElement('a');
        row.className = 'header__search-result' + (soldOut ? ' header__search-result--soldout' : '');
        row.href = p.url;
        row.id = 'header-search-option-' + i;
        row.setAttribute('role', 'option');

        var thumb = document.createElement('span');
        thumb.className = 'header__search-thumb';
        var src = thumbUrl(p);
        if (src) {
          var img = document.createElement('img');
          img.src = src;
          img.alt = '';
          img.loading = 'lazy';
          img.width = 96;
          img.height = 96;
          thumb.appendChild(img);
        }
        row.appendChild(thumb);

        var body = document.createElement('span');
        body.className = 'header__search-result-body';
        var title = document.createElement('span');
        title.className = 'header__search-result-title';
        appendHighlighted(title, p.title || '', query);
        body.appendChild(title);
        if (p.type) {
          var meta = document.createElement('span');
          meta.className = 'header__search-result-meta';
          meta.textContent = p.type;
          body.appendChild(meta);
        }
        row.appendChild(body);

        var side = document.createElement('span');
        side.className = 'header__search-result-price';
        if (soldOut) {
          var chip = document.createElement('span');
          chip.className = 'header__search-soldout';
          chip.textContent = 'Sold out';
          side.appendChild(chip);
        } else {
          side.textContent = priceLabel(p);
        }
        row.appendChild(side);

        row.addEventListener('click', function () { saveRecent(query); });
        resultsEl.appendChild(row);
      });

      var viewAll = document.createElement('a');
      viewAll.className = 'header__search-viewall';
      viewAll.href = searchUrl + '?q=' + encodeURIComponent(query) + '&type=product';
      viewAll.id = 'header-search-option-' + products.length;
      viewAll.setAttribute('role', 'option');
      viewAll.textContent = products.length ? 'View all results →' : 'Search the full site →';
      viewAll.addEventListener('click', function () { saveRecent(query); });
      resultsEl.appendChild(viewAll);

      options = Array.prototype.slice.call(resultsEl.querySelectorAll('[role="option"]'));
      activeIndex = -1;
      options.forEach(function (opt, i) {
        opt.addEventListener('mousemove', function () {
          if (activeIndex !== i) setActive(i, false);
        });
      });

      if (defaultEl) defaultEl.hidden = true;
      resultsEl.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function runSearch(query) {
      var key = query.toLowerCase();
      if (cache[key]) {
        renderResults(query, cache[key]);
        return;
      }
      if (controller) controller.abort();
      controller = window.AbortController ? new AbortController() : null;
      if (spinner) spinner.hidden = false;
      var url = predictiveUrl + '.json?q=' + encodeURIComponent(query) +
        '&resources[type]=product' +
        '&resources[limit]=' + MAX_RESULTS +
        '&resources[options][unavailable_products]=last' +
        '&resources[options][fields]=title,product_type,variants.title,vendor,tag';
      fetch(url, controller ? { signal: controller.signal } : undefined)
        .then(function (res) {
          if (!res.ok) throw new Error('predictive search HTTP ' + res.status);
          return res.json();
        })
        .then(function (data) {
          var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
          // Add-ons are upgrades sold on their event's page, not standalone
          // results — same rule as the /search results template.
          products = products.filter(function (p) {
            return String(p.type || '').toLowerCase() !== 'add-on';
          });
          cache[key] = products;
          cacheKeys.push(key);
          if (cacheKeys.length > 30) delete cache[cacheKeys.shift()];
          if (spinner) spinner.hidden = true;
          if (input.value.trim().toLowerCase() === key) renderResults(query, products);
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          if (spinner) spinner.hidden = true;
          // API hiccup: the empty state still offers the full /search page.
          if (input.value.trim().toLowerCase() === key) renderResults(query, []);
        });
    }

    function isOpen() {
      return modal.open;
    }

    function openSearch() {
      if (modal.open) return;
      if (typeof modal.showModal === 'function') modal.showModal();
      else modal.setAttribute('open', '');
      renderRecent();
      requestAnimationFrame(function () {
        input.focus();
        input.select();
      });
    }

    function closeSearch() {
      if (modal.open) modal.close();
      else modal.removeAttribute('open');
    }

    document.querySelectorAll('[data-search-open]').forEach(function (btn) {
      btn.addEventListener('click', openSearch);
    });

    modal.querySelectorAll('[data-search-close]').forEach(function (btn) {
      btn.addEventListener('click', closeSearch);
    });

    // Backdrop / outside-panel clicks land on the dialog element itself.
    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeSearch();
    });

    modal.addEventListener('close', function () {
      if (spinner) spinner.hidden = true;
    });

    // Cmd/Ctrl+K toggles; plain `/` opens unless the visitor is typing
    // somewhere else or another dialog (e.g. the mobile nav) is up.
    document.addEventListener('keydown', function (e) {
      if (e.defaultPrevented) return;
      if ((e.metaKey || e.ctrlKey) && !e.shiftKey && !e.altKey && (e.key === 'k' || e.key === 'K')) {
        e.preventDefault();
        if (isOpen()) closeSearch();
        else openSearch();
        return;
      }
      if (e.key === '/' && !isOpen() && !e.metaKey && !e.ctrlKey && !e.altKey) {
        var t = e.target;
        if (t && t.closest && t.closest('input, textarea, select, [contenteditable="true"]')) return;
        if (document.querySelector('dialog[open]')) return;
        e.preventDefault();
        openSearch();
      }
    });

    input.addEventListener('input', function () {
      var q = input.value.trim();
      if (clearBtn) clearBtn.hidden = q.length === 0;
      if (debounceTimer) clearTimeout(debounceTimer);
      if (q.length < 2) {
        showDefault();
        return;
      }
      if (q === lastQuery) return;
      debounceTimer = setTimeout(function () {
        lastQuery = q;
        runSearch(q);
      }, 200);
    });

    input.addEventListener('keydown', function (e) {
      if (resultsEl.hidden || !options.length) return;
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        setActive((activeIndex + 1) % options.length, true);
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        setActive(activeIndex <= 0 ? options.length - 1 : activeIndex - 1, true);
      } else if (e.key === 'Enter' && activeIndex > -1 && options[activeIndex]) {
        e.preventDefault();
        options[activeIndex].click();
      }
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        input.value = '';
        clearBtn.hidden = true;
        showDefault();
        input.focus();
      });
    }

    // Popular + recent chips (recent are stamped in later — delegated).
    modal.addEventListener('click', function (e) {
      var chip = e.target.closest ? e.target.closest('[data-search-term]') : null;
      if (!chip) return;
      input.value = chip.dataset.searchTerm || chip.textContent;
      var q = input.value.trim();
      if (clearBtn) clearBtn.hidden = q.length === 0;
      input.focus();
      if (q.length >= 2) {
        lastQuery = q;
        runSearch(q);
      }
    });

    var forgetBtn = modal.querySelector('[data-search-forget]');
    if (forgetBtn) {
      forgetBtn.addEventListener('click', function () {
        try { localStorage.removeItem(RECENT_KEY); } catch (e) { /* ignore */ }
        renderRecent();
      });
    }

    // Plain GET to /search?q=…&type=product — just remember the term first.
    form.addEventListener('submit', function (e) {
      var q = input.value.trim();
      if (!q) {
        e.preventDefault();
        return;
      }
      saveRecent(q);
    });
  })();
  });
